export default {"src":"/_next/static/media/list-style-arrow.c97eeb57.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};